import React from 'react';

const AnticlockwiseArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M4.27558 13.5935C4.04134 13.8278 4.04134 14.2077 4.27558 14.4421L9.07558 19.2421C9.30994 19.4763 9.68986 19.4763 9.92422 19.2421L14.7242 14.4421C14.9585 14.2077 14.9585 13.8278 14.7242 13.5935C14.4899 13.3592 14.11 13.3592 13.8756 13.5935L10.0999 17.3693L10.0999 9.81777C10.0999 8.49229 11.1744 7.41777 12.4999 7.41777L20.2999 7.41777C20.6313 7.41777 20.8999 7.14914 20.8999 6.81777C20.8999 6.48641 20.6313 6.21777 20.2999 6.21777L12.4999 6.21777C10.5116 6.21777 8.8999 7.82955 8.8999 9.81777L8.8999 17.3693L5.12422 13.5935C4.88986 13.3592 4.50994 13.3592 4.27558 13.5935Z"
      fill="#153142"
    />
  </svg>
);

export default AnticlockwiseArrow;
